import { useContext } from "react";
import { ToastsContext } from "./toasts-provider";

const useToasts = () => useContext(ToastsContext);

export default useToasts;